const IhgGuide = () => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
    <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>IHG Hotels AI Assistant Capabilities</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Allerta&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap" rel="stylesheet">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Allerta', Arial, sans-serif;
        }
        
        body {
            background-color: #f5f5f5;
            color: #333;
            line-height: 1.5;
            font-size: 16px;
        }
        
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
        }
        
        /* Header */
        .header {
            background-color: white;
            color: #047ED8;
            padding: 20px;
            text-align: center;
            margin-bottom: 30px;
        }
        
        .header img {
            height: 80px;
            margin-bottom: 15px;
        }
        
        .header h1 {
            font-size: 32px;
            margin-bottom: 10px;
            font-weight: bold;
        }
        
        .header p {
            font-size: 18px;
            color: #047ED8;
        }
        
        /* Overview */
        .overview {
            background-color: white;
            padding: 20px;
            margin-bottom: 30px;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .overview h2 {
            color: #047ED8;
            margin-bottom: 15px;
            border-bottom: 2px solid #FFC72C;
            padding-bottom: 10px;
            font-size: 24px;
        }
        
        .overview p {
            margin-bottom: 10px;
            line-height: 1.6;
        }
        
        /* Section Headers */
        .section-header {
            background-color: #047ED8;
            color: white;
            padding: 15px;
            margin: 30px 0 15px;
            border-radius: 5px;
            display: flex;
            align-items: center;
        }
        
        .section-header .icon {
            margin-right: 15px;
            font-size: 24px;
        }
        
        .section-header h2 {
            font-size: 20px;
            font-weight: 600;
        }
        
        /* Content Cards */
        .card {
            background-color: white;
            padding: 20px;
            margin-bottom: 20px;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        /* List Styling */
        ul {
            list-style-type: none;
        }
        
        li {
            padding: 10px 0;
            position: relative;
            padding-left: 20px;
            display: flex;
            flex-wrap: wrap;
            line-height: 1.4;
        }
        
        li::before {
            content: "•";
            color: #C51A1B;
            font-weight: bold;
            position: absolute;
            left: 0;
        }
        
        .blue-text {
            color: #047ED8;
            font-weight: bold;
            margin-right: 5px;
        }
        
        .text-spacer {
            display: inline-block;
            width: 5px;
        }
        
        /* Action Items */
        .action-item {
            background-color: #f5f5f5;
            padding: 14px;
            margin-bottom: 12px;
            border-radius: 5px;
            border-left: 3px solid #FFC72C;
            line-height: 1.4;
        }
        
        /* Footer */
        .footer {
            background-color: #047ED8;
            color: white;
            text-align: center;
            padding: 15px;
            margin-top: 30px;
            border-radius: 5px;
            font-size: 14px;
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
            .container {
                padding: 10px;
            }
            
            .header h1 {
                font-size: 26px;
            }
            
            .header p {
                font-size: 16px;
            }
            
            .section-header h2 {
                font-size: 18px;
            }
            
            .overview h2 {
                font-size: 20px;
            }
        }
        
        @media (max-width: 480px) {
            .header h1 {
                font-size: 22px;
            }
            
            .overview p {
                font-size: 15px;
            }
            
            li, .action-item {
                font-size: 15px;
            }
        }
    </style>
</head>
<body>
    <div class="header">
        <img src="https://cdn.prod.website-files.com/665dbdf119ee43cd42be2657/665dfa4ae79bf116e4bb5ec0_Group%202745%402x-p-500.png" alt="IHG Hotels Logo">
        <h1>AI Assistant Capabilities</h1>
        <p>Enhancing Guest Experience Through Intelligent Assistance</p>
    </div>
    
    <div class="container">
        <!-- Overview Section -->
        <div class="overview">
            <h2>Overview</h2>
            <p>The IHG Hotels AI Assistant is designed to transform guest interactions by providing immediate, accurate responses to inquiries and facilitating seamless hotel experiences. This intelligent system handles everything from detailed room information to complex booking processes, helping guests make informed decisions quickly.</p>
            <p>Our AI Assistant serves as a 24/7 virtual concierge, offering personalized support while reducing wait times and enhancing overall satisfaction. It can answer questions, process requests, and connect guests with human agents when needed for more specialized assistance.</p>
        </div>
        
        <!-- Room Information -->
        <div class="section-header">
            <div class="icon">🛏️</div>
            <h2>Room Information</h2>
        </div>
        
        <div class="card">
            <ul>
                <li><span class="blue-text">Detailed descriptions</span>&nbsp;of all room types at specific properties</li>
                <li>Room&nbsp;<span class="blue-text">sizes, layouts,</span>&nbsp;and&nbsp;<span class="blue-text">special features</span></li>
                <li>Maximum&nbsp;<span class="blue-text">occupancy limits</span></li>
                <li>Room-specific&nbsp;<span class="blue-text">amenities</span>&nbsp;(King beds, sofa beds, accessible features)</li>
                <li>Available&nbsp;<span class="blue-text">views</span>&nbsp;and room locations</li>
            </ul>
        </div>
        
        <!-- Booking & Reservations -->
        <div class="section-header">
            <div class="icon">📅</div>
            <h2>Booking & Reservations</h2>
        </div>
        
        <div class="card">
            <ul>
                <li><span class="blue-text">Check-in/check-out</span>&nbsp;times</li>
                <li>Booking&nbsp;<span class="blue-text">policies</span>&nbsp;and procedures</li>
                <li><span class="blue-text">Early check-in</span>&nbsp;and&nbsp;<span class="blue-text">late check-out</span>&nbsp;requests</li>
                <li><span class="blue-text">Cancellation policies</span></li>
                <li><span class="blue-text">Credit card</span>&nbsp;requirements</li>
                <li><span class="blue-text">Group booking</span>&nbsp;procedures</li>
                <li><span class="blue-text">Best rate</span>&nbsp;guarantees</li>
                <li><span class="blue-text">Availability</span>&nbsp;for specific dates</li>
            </ul>
        </div>
        
        <!-- Hotel Amenities -->
        <div class="section-header">
            <div class="icon">🏊</div>
            <h2>Hotel Amenities</h2>
        </div>
        
        <div class="card">
            <ul>
                <li><span class="blue-text">Swimming pool</span>&nbsp;and hot tub information</li>
                <li><span class="blue-text">Fitness center</span>&nbsp;details</li>
                <li><span class="blue-text">Business center</span>&nbsp;services</li>
                <li><span class="blue-text">Airport shuttle</span>&nbsp;schedules</li>
                <li><span class="blue-text">Wi-Fi</span>&nbsp;access</li>
                <li><span class="blue-text">Laundry services</span></li>
                <li><span class="blue-text">Executive lounge</span>&nbsp;access (for applicable rooms)</li>
                <li><span class="blue-text">EV charging</span>&nbsp;stations</li>
            </ul>
        </div>
        
        <!-- Dining Options -->
        <div class="section-header">
            <div class="icon">🍽️</div>
            <h2>Dining Options</h2>
        </div>
        
        <div class="card">
            <ul>
                <li><span class="blue-text">Restaurant hours</span>&nbsp;and cuisine types</li>
                <li><span class="blue-text">Breakfast options</span>&nbsp;(continental, American, buffet)</li>
                <li><span class="blue-text">Kid-friendly</span>&nbsp;dining options</li>
                <li><span class="blue-text">Room service</span>&nbsp;availability</li>
                <li><span class="blue-text">Nearby dining</span>&nbsp;recommendations</li>
            </ul>
        </div>
        
        <!-- Hotel Location & Surroundings -->
        <div class="section-header">
            <div class="icon">📍</div>
            <h2>Location & Surroundings</h2>
        </div>
        
        <div class="card">
            <ul>
                <li>Precise&nbsp;<span class="blue-text">location details</span>&nbsp;and directions</li>
                <li><span class="blue-text">Distance</span>&nbsp;from airports and transportation hubs</li>
                <li><span class="blue-text">Nearby attractions</span>&nbsp;and distances</li>
                <li><span class="blue-text">Transportation options</span>&nbsp;(including hotel shuttles)</li>
                <li><span class="blue-text">Parking information</span>&nbsp;and costs</li>
            </ul>
        </div>
        
        <!-- Accessibility Features -->
        <div class="section-header">
            <div class="icon">♿</div>
            <h2>Accessibility Features</h2>
        </div>
        
        <div class="card">
            <ul>
                <li><span class="blue-text">Accessible room</span>&nbsp;options</li>
                <li>Property&nbsp;<span class="blue-text">accessibility features</span></li>
                <li><span class="blue-text">Special accommodations</span></li>
            </ul>
        </div>
        
        <!-- Actions Guests Can Take -->
        <div class="section-header">
            <div class="icon">🤖</div>
            <h2>Actions Guests Can Take</h2>
        </div>
        
        <div class="card">
            <div class="action-item">1. <span class="blue-text">Make room reservations</span>&nbsp;and complete bookings directly through the assistant</div>
            <div class="action-item">2. Get&nbsp;<span class="blue-text">instant answers</span>&nbsp;to FAQs without waiting for human assistance</div>
            <div class="action-item">3. Request&nbsp;<span class="blue-text">detailed information</span>&nbsp;about specific room types</div>
            <div class="action-item">4. Learn about current&nbsp;<span class="blue-text">promotions</span>&nbsp;and special offers</div>
            <div class="action-item">5. Check&nbsp;<span class="blue-text">room rates</span>&nbsp;and availability for specific dates</div>
            <div class="action-item">6. <span class="blue-text">Compare</span>&nbsp;different room types and their amenities</div>
            <div class="action-item">7. Inquire about hotel&nbsp;<span class="blue-text">policies</span>&nbsp;before booking</div>
            <div class="action-item">8. Arrange&nbsp;<span class="blue-text">airport shuttle</span>&nbsp;transportation</div>
            <div class="action-item">9. Understand available&nbsp;<span class="blue-text">dining options</span>&nbsp;and meal plans</div>
            <div class="action-item">10. Get&nbsp;<span class="blue-text">directions</span>&nbsp;and transportation information</div>
            <div class="action-item">11. Learn about hotel&nbsp;<span class="blue-text">amenities</span>&nbsp;and operating hours</div>
            <div class="action-item">12. Ask for&nbsp;<span class="blue-text">images</span>&nbsp;of rooms, facilities, or dining options</div>
            <div class="action-item">13. Request to speak with a&nbsp;<span class="blue-text">human agent</span>&nbsp;for complex inquiries or reservations</div>
        </div>
        
        <div class="footer">
            <p>© 2025 Hotelzify | AI Assistant Capabilities Documentation</p>
        </div>
    </div>
</body>
</html>
    `,
      }}
    />
  );
};

export default IhgGuide;
